import { atom } from "jotai";

export type FtlStop = {
	id: string;
	orderIndex: number;
};

export type FtlQuote = {
	quoteId: number;
	rate: number | null;
	stops: FtlStop[];
};

export const activeFtlQuoteAtom = atom<FtlQuote | null>(null);
